import CommoditiesIcon from '@material-ui/icons/Shop';

import { CommoditiesCreate } from './Create/Create';
import { CommoditiesEdit } from './Edit/Edit';
import { CommoditiesList } from './List/List';


export {
	CommoditiesList,
	CommoditiesCreate,
	CommoditiesEdit,
};

export const commoditiesResource = {
	list: CommoditiesList,
	edit: CommoditiesEdit,
	create: CommoditiesCreate,
	icon: CommoditiesIcon,
};
